import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  RdsDialogModule,
  RdsButtonModule,
  RdsFormFieldModule,
  RDS_DIALOG_DATA,
  RdsDialogRef,
} from '@rds/angular-components';
import { BUTTON_TEXTS } from '../../../../constants/buttons.constants';
import { ERRORS_TEXTS } from '../../../../constants/errors.contstants';
import { KnowledgeLearningResource } from '../../../../models/knowledge';
import { urlValidator } from '../../../../validators';
import { POPUPS } from '../../../../constants/popups.constants';

@Component({
  selector: 'inexp-focus-learning-resource-dialog',
  imports: [
    ReactiveFormsModule,
    RdsDialogModule,
    RdsButtonModule,
    RdsFormFieldModule,
  ],
  templateUrl: './focus-learning-resource-dialog.component.html',
  styleUrl: './focus-learning-resource-dialog.component.scss',
})
export class FocusLearningResourceDialogComponent {
  private readonly _fb = inject(FormBuilder);
  private readonly _dialogRef =
    inject<RdsDialogRef<FocusLearningResourceDialogComponent>>(RdsDialogRef);
  protected readonly data = inject(RDS_DIALOG_DATA) as {
    learningResources?: KnowledgeLearningResource;
  };
  readonly ERRORS = ERRORS_TEXTS;
  readonly BUTTONS = BUTTON_TEXTS;
  readonly POPUPS = POPUPS;

  form = this._fb.group({
    title: [this.data.learningResources?.title ?? '', Validators.required],
    url: [
      this.data.learningResources?.url ?? '',
      [Validators.required, urlValidator()],
    ],
  });

  submit() {
    if (this.form.valid) {
      this._dialogRef.close(this.form.value);
    } else {
      this.form.markAllAsTouched();
    }
  }
}
